import { useMutation } from '@tanstack/react-query';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import { createPastor, createManyPastors } from '../functions/pastors';

export const useCreatePastor = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createPastor,
    mutationKey: ['create-pastor'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating pastor', e);
    }
  });
};

export const useCreateManyPastors = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationFn: createManyPastors,
    mutationKey: ['create-many-pastors'],
    onError: (e: any) => {
      showError({});
      console.error('Error creating pastors', e);
    }
  });
};
